import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BaseAutoCompleteWithSingleSelectedItem from '@/components/AutoCompletes/BaseAutoCompleteWithSingleSelectedItem.vue';
import getManagementOffice from '@/types/responses/getManagementOffice';
import { onMounted, ref, computed, watch } from 'vue';
import Api from '@/services/api/ApiServiceFabrick';


export default /*@__PURE__*/_defineComponent({
  __name: 'ManagementOfficeAutoComplete',
  props: {
    modelValue: {},
    selectFirstIfOnlyOne: { type: Boolean },
    initialManagementId: {},
    initialManagementType: {},
    errorMessages: {},
    clearable: { type: Boolean, default: true },
    readonly: { type: Boolean },
    disabled: { type: Boolean, default: false }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit;

const items = ref<getManagementOffice[]>([]);

onMounted(() => {
  Api()
    .autoCompleteManagementOffices()
    .then((data) => {
      items.value = data;
      setModelValue()
    });
});

watch(
  () => [props.initialManagementId, props.initialManagementType],
  () => {
    setModelValue();
  }
);

const localModelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
})

const setModelValue = () => {
  const filteredItems = items.value;
  if (props.initialManagementId && props.initialManagementType) {
    localModelValue.value = filteredItems.filter((item) => {
      return item.id === props.initialManagementId && item.type === props.initialManagementType
    })[0];
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseAutoCompleteWithSingleSelectedItem, {
    readonly: __props.readonly,
    disabled: __props.disabled,
    modelValue: localModelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((localModelValue).value = $event)),
    label: "管理会社",
    itemName: "name",
    items: items.value,
    errorMessages: props.errorMessages,
    clearable: props.clearable,
    selectFirstIfOnlyOne: props.selectFirstIfOnlyOne
  }, null, 8, ["readonly", "disabled", "modelValue", "items", "errorMessages", "clearable", "selectFirstIfOnlyOne"]))
}
}

})